import SortingChoice from './sorting-choice';

// eslint-disable-next-line @wordpress/no-global-event-listener
document.addEventListener( 'DOMContentLoaded', function( event ) {
	SortingChoice();
} );
